<template>
  <td class="expandable-row">
    <div
      class="expandable-row__icon"
      :class="{ 'expandable-row__expanded': $parent.expandableItems[index] }"
      @click="$parent.toggleExpandedRow(index)"
    >
      <i class="fa fa-caret-down" v-if="$parent.expandableItems[index]" />
      <i class="fa fa-caret-right" v-else />
    </div>
  </td>
</template>

<script>
export default {
  name: 'ExpandableColumn',
  props: ['index']
}
</script>
